import React from 'react';
import { Switch } from 'react-router';
import AppPaths from '../../AppPaths';
import SentryRoute from '../../SentryRoute';
import UltraUpgradeSelection from './UltraUpgradeSelection';
import UltraUpgradeComplete from './UltraUpgradeComplete';

export default function UltraUpgrade() {
  return (
    <Switch>
      <SentryRoute exact path={AppPaths.UltraUpgrade.Complete} component={UltraUpgradeComplete} />
      <SentryRoute exact path={AppPaths.UltraUpgrade.PlanSelection} component={UltraUpgradeSelection} />
    </Switch>
  );
}
